/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password/$token'
import { Route as AcceptInvitationTokenRouteImport } from './routes/accept-invitation/$token'
import { Route as AuthenticatedNoSupplyPointsRouteImport } from './routes/_authenticated/no-supply-points'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedSupplyPointScopeRouteImport } from './routes/_authenticated/_supply-point-scope'
import { Route as AuthenticatedProfileRouteRouteImport } from './routes/_authenticated/profile/route'
import { Route as AuthenticatedOrganizationsRouteRouteImport } from './routes/_authenticated/organizations/route'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedOrganizationsIndexRouteImport } from './routes/_authenticated/organizations/index'
import { Route as AuthenticatedSupplyPointScopeIndexRouteImport } from './routes/_authenticated/_supply-point-scope/index'
import { Route as VerifyUidb64TokenRouteImport } from './routes/verify/$uidb64/$token'
import { Route as AuthenticatedSupplyPointsNewRouteImport } from './routes/_authenticated/supply-points/new'
import { Route as AuthenticatedProfileSecurityRouteImport } from './routes/_authenticated/profile/security'
import { Route as AuthenticatedProfilePersonalInfoRouteImport } from './routes/_authenticated/profile/personal-info'
import { Route as AuthenticatedSupplyPointScopeProductsRouteImport } from './routes/_authenticated/_supply-point-scope/products'
import { Route as AuthenticatedOrganizationsOrganizationIdRouteRouteImport } from './routes/_authenticated/organizations/$organizationId/route'
import { Route as AuthenticatedSupplyPointScopeSettingsRouteRouteImport } from './routes/_authenticated/_supply-point-scope/settings/route'
import { Route as AuthenticatedSupplyPointScopeDevicesRouteRouteImport } from './routes/_authenticated/_supply-point-scope/devices/route'
import { Route as AuthenticatedOrganizationsOrganizationIdIndexRouteImport } from './routes/_authenticated/organizations/$organizationId/index'
import { Route as AuthenticatedSupplyPointScopeSettingsIndexRouteImport } from './routes/_authenticated/_supply-point-scope/settings/index'
import { Route as AuthenticatedSupplyPointScopeDevicesIndexRouteImport } from './routes/_authenticated/_supply-point-scope/devices/index'
import { Route as AuthenticatedOrganizationsOrganizationIdSupplyPointsRouteImport } from './routes/_authenticated/organizations/$organizationId/supply-points'
import { Route as AuthenticatedOrganizationsOrganizationIdSettingsRouteImport } from './routes/_authenticated/organizations/$organizationId/settings'
import { Route as AuthenticatedOrganizationsOrganizationIdMembersRouteImport } from './routes/_authenticated/organizations/$organizationId/members'
import { Route as AuthenticatedOrganizationsOrganizationIdBillingRouteImport } from './routes/_authenticated/organizations/$organizationId/billing'
import { Route as AuthenticatedSupplyPointScopeSettingsDetailsRouteImport } from './routes/_authenticated/_supply-point-scope/settings/details'
import { Route as AuthenticatedSupplyPointScopeSettingsAccessRouteImport } from './routes/_authenticated/_supply-point-scope/settings/access'
import { Route as AuthenticatedSupplyPointScopeDevicesNewRouteImport } from './routes/_authenticated/_supply-point-scope/devices/new'
import { Route as AuthenticatedSupplyPointScopeDevicesDeviceIdEditRouteImport } from './routes/_authenticated/_supply-point-scope/devices/$deviceId/edit'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationTokenRoute = AcceptInvitationTokenRouteImport.update({
  id: '/accept-invitation/$token',
  path: '/accept-invitation/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedNoSupplyPointsRoute =
  AuthenticatedNoSupplyPointsRouteImport.update({
    id: '/no-supply-points',
    path: '/no-supply-points',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSupplyPointScopeRoute =
  AuthenticatedSupplyPointScopeRouteImport.update({
    id: '/_supply-point-scope',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRouteRoute =
  AuthenticatedProfileRouteRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationsRouteRoute =
  AuthenticatedOrganizationsRouteRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProfileRouteRoute,
  } as any)
const AuthenticatedOrganizationsIndexRoute =
  AuthenticatedOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationsRouteRoute,
  } as any)
const AuthenticatedSupplyPointScopeIndexRoute =
  AuthenticatedSupplyPointScopeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSupplyPointScopeRoute,
  } as any)
const VerifyUidb64TokenRoute = VerifyUidb64TokenRouteImport.update({
  id: '/verify/$uidb64/$token',
  path: '/verify/$uidb64/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSupplyPointsNewRoute =
  AuthenticatedSupplyPointsNewRouteImport.update({
    id: '/supply-points/new',
    path: '/supply-points/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileSecurityRoute =
  AuthenticatedProfileSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedProfileRouteRoute,
  } as any)
const AuthenticatedProfilePersonalInfoRoute =
  AuthenticatedProfilePersonalInfoRouteImport.update({
    id: '/personal-info',
    path: '/personal-info',
    getParentRoute: () => AuthenticatedProfileRouteRoute,
  } as any)
const AuthenticatedSupplyPointScopeProductsRoute =
  AuthenticatedSupplyPointScopeProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedSupplyPointScopeRoute,
  } as any)
const AuthenticatedOrganizationsOrganizationIdRouteRoute =
  AuthenticatedOrganizationsOrganizationIdRouteRouteImport.update({
    id: '/$organizationId',
    path: '/$organizationId',
    getParentRoute: () => AuthenticatedOrganizationsRouteRoute,
  } as any)
const AuthenticatedSupplyPointScopeSettingsRouteRoute =
  AuthenticatedSupplyPointScopeSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedSupplyPointScopeRoute,
  } as any)
const AuthenticatedSupplyPointScopeDevicesRouteRoute =
  AuthenticatedSupplyPointScopeDevicesRouteRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => AuthenticatedSupplyPointScopeRoute,
  } as any)
const AuthenticatedOrganizationsOrganizationIdIndexRoute =
  AuthenticatedOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationsOrganizationIdRouteRoute,
  } as any)
const AuthenticatedSupplyPointScopeSettingsIndexRoute =
  AuthenticatedSupplyPointScopeSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSupplyPointScopeSettingsRouteRoute,
  } as any)
const AuthenticatedSupplyPointScopeDevicesIndexRoute =
  AuthenticatedSupplyPointScopeDevicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSupplyPointScopeDevicesRouteRoute,
  } as any)
const AuthenticatedOrganizationsOrganizationIdSupplyPointsRoute =
  AuthenticatedOrganizationsOrganizationIdSupplyPointsRouteImport.update({
    id: '/supply-points',
    path: '/supply-points',
    getParentRoute: () => AuthenticatedOrganizationsOrganizationIdRouteRoute,
  } as any)
const AuthenticatedOrganizationsOrganizationIdSettingsRoute =
  AuthenticatedOrganizationsOrganizationIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedOrganizationsOrganizationIdRouteRoute,
  } as any)
const AuthenticatedOrganizationsOrganizationIdMembersRoute =
  AuthenticatedOrganizationsOrganizationIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedOrganizationsOrganizationIdRouteRoute,
  } as any)
const AuthenticatedOrganizationsOrganizationIdBillingRoute =
  AuthenticatedOrganizationsOrganizationIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedOrganizationsOrganizationIdRouteRoute,
  } as any)
const AuthenticatedSupplyPointScopeSettingsDetailsRoute =
  AuthenticatedSupplyPointScopeSettingsDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthenticatedSupplyPointScopeSettingsRouteRoute,
  } as any)
const AuthenticatedSupplyPointScopeSettingsAccessRoute =
  AuthenticatedSupplyPointScopeSettingsAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AuthenticatedSupplyPointScopeSettingsRouteRoute,
  } as any)
const AuthenticatedSupplyPointScopeDevicesNewRoute =
  AuthenticatedSupplyPointScopeDevicesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedSupplyPointScopeDevicesRouteRoute,
  } as any)
const AuthenticatedSupplyPointScopeDevicesDeviceIdEditRoute =
  AuthenticatedSupplyPointScopeDevicesDeviceIdEditRouteImport.update({
    id: '/$deviceId/edit',
    path: '/$deviceId/edit',
    getParentRoute: () => AuthenticatedSupplyPointScopeDevicesRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedSupplyPointScopeIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/organizations': typeof AuthenticatedOrganizationsRouteRouteWithChildren
  '/profile': typeof AuthenticatedProfileRouteRouteWithChildren
  '/billing': typeof AuthenticatedBillingRoute
  '/no-supply-points': typeof AuthenticatedNoSupplyPointsRoute
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/devices': typeof AuthenticatedSupplyPointScopeDevicesRouteRouteWithChildren
  '/settings': typeof AuthenticatedSupplyPointScopeSettingsRouteRouteWithChildren
  '/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdRouteRouteWithChildren
  '/products': typeof AuthenticatedSupplyPointScopeProductsRoute
  '/profile/personal-info': typeof AuthenticatedProfilePersonalInfoRoute
  '/profile/security': typeof AuthenticatedProfileSecurityRoute
  '/supply-points/new': typeof AuthenticatedSupplyPointsNewRoute
  '/verify/$uidb64/$token': typeof VerifyUidb64TokenRoute
  '/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
  '/devices/new': typeof AuthenticatedSupplyPointScopeDevicesNewRoute
  '/settings/access': typeof AuthenticatedSupplyPointScopeSettingsAccessRoute
  '/settings/details': typeof AuthenticatedSupplyPointScopeSettingsDetailsRoute
  '/organizations/$organizationId/billing': typeof AuthenticatedOrganizationsOrganizationIdBillingRoute
  '/organizations/$organizationId/members': typeof AuthenticatedOrganizationsOrganizationIdMembersRoute
  '/organizations/$organizationId/settings': typeof AuthenticatedOrganizationsOrganizationIdSettingsRoute
  '/organizations/$organizationId/supply-points': typeof AuthenticatedOrganizationsOrganizationIdSupplyPointsRoute
  '/devices/': typeof AuthenticatedSupplyPointScopeDevicesIndexRoute
  '/settings/': typeof AuthenticatedSupplyPointScopeSettingsIndexRoute
  '/organizations/$organizationId/': typeof AuthenticatedOrganizationsOrganizationIdIndexRoute
  '/devices/$deviceId/edit': typeof AuthenticatedSupplyPointScopeDevicesDeviceIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedSupplyPointScopeIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/billing': typeof AuthenticatedBillingRoute
  '/no-supply-points': typeof AuthenticatedNoSupplyPointsRoute
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/products': typeof AuthenticatedSupplyPointScopeProductsRoute
  '/profile/personal-info': typeof AuthenticatedProfilePersonalInfoRoute
  '/profile/security': typeof AuthenticatedProfileSecurityRoute
  '/supply-points/new': typeof AuthenticatedSupplyPointsNewRoute
  '/verify/$uidb64/$token': typeof VerifyUidb64TokenRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/devices/new': typeof AuthenticatedSupplyPointScopeDevicesNewRoute
  '/settings/access': typeof AuthenticatedSupplyPointScopeSettingsAccessRoute
  '/settings/details': typeof AuthenticatedSupplyPointScopeSettingsDetailsRoute
  '/organizations/$organizationId/billing': typeof AuthenticatedOrganizationsOrganizationIdBillingRoute
  '/organizations/$organizationId/members': typeof AuthenticatedOrganizationsOrganizationIdMembersRoute
  '/organizations/$organizationId/settings': typeof AuthenticatedOrganizationsOrganizationIdSettingsRoute
  '/organizations/$organizationId/supply-points': typeof AuthenticatedOrganizationsOrganizationIdSupplyPointsRoute
  '/devices': typeof AuthenticatedSupplyPointScopeDevicesIndexRoute
  '/settings': typeof AuthenticatedSupplyPointScopeSettingsIndexRoute
  '/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdIndexRoute
  '/devices/$deviceId/edit': typeof AuthenticatedSupplyPointScopeDevicesDeviceIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authenticated/organizations': typeof AuthenticatedOrganizationsRouteRouteWithChildren
  '/_authenticated/profile': typeof AuthenticatedProfileRouteRouteWithChildren
  '/_authenticated/_supply-point-scope': typeof AuthenticatedSupplyPointScopeRouteWithChildren
  '/_authenticated/billing': typeof AuthenticatedBillingRoute
  '/_authenticated/no-supply-points': typeof AuthenticatedNoSupplyPointsRoute
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/_authenticated/_supply-point-scope/devices': typeof AuthenticatedSupplyPointScopeDevicesRouteRouteWithChildren
  '/_authenticated/_supply-point-scope/settings': typeof AuthenticatedSupplyPointScopeSettingsRouteRouteWithChildren
  '/_authenticated/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdRouteRouteWithChildren
  '/_authenticated/_supply-point-scope/products': typeof AuthenticatedSupplyPointScopeProductsRoute
  '/_authenticated/profile/personal-info': typeof AuthenticatedProfilePersonalInfoRoute
  '/_authenticated/profile/security': typeof AuthenticatedProfileSecurityRoute
  '/_authenticated/supply-points/new': typeof AuthenticatedSupplyPointsNewRoute
  '/verify/$uidb64/$token': typeof VerifyUidb64TokenRoute
  '/_authenticated/_supply-point-scope/': typeof AuthenticatedSupplyPointScopeIndexRoute
  '/_authenticated/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/_supply-point-scope/devices/new': typeof AuthenticatedSupplyPointScopeDevicesNewRoute
  '/_authenticated/_supply-point-scope/settings/access': typeof AuthenticatedSupplyPointScopeSettingsAccessRoute
  '/_authenticated/_supply-point-scope/settings/details': typeof AuthenticatedSupplyPointScopeSettingsDetailsRoute
  '/_authenticated/organizations/$organizationId/billing': typeof AuthenticatedOrganizationsOrganizationIdBillingRoute
  '/_authenticated/organizations/$organizationId/members': typeof AuthenticatedOrganizationsOrganizationIdMembersRoute
  '/_authenticated/organizations/$organizationId/settings': typeof AuthenticatedOrganizationsOrganizationIdSettingsRoute
  '/_authenticated/organizations/$organizationId/supply-points': typeof AuthenticatedOrganizationsOrganizationIdSupplyPointsRoute
  '/_authenticated/_supply-point-scope/devices/': typeof AuthenticatedSupplyPointScopeDevicesIndexRoute
  '/_authenticated/_supply-point-scope/settings/': typeof AuthenticatedSupplyPointScopeSettingsIndexRoute
  '/_authenticated/organizations/$organizationId/': typeof AuthenticatedOrganizationsOrganizationIdIndexRoute
  '/_authenticated/_supply-point-scope/devices/$deviceId/edit': typeof AuthenticatedSupplyPointScopeDevicesDeviceIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/sign-up'
    | '/verify-email'
    | '/organizations'
    | '/profile'
    | '/billing'
    | '/no-supply-points'
    | '/accept-invitation/$token'
    | '/reset-password/$token'
    | '/devices'
    | '/settings'
    | '/organizations/$organizationId'
    | '/products'
    | '/profile/personal-info'
    | '/profile/security'
    | '/supply-points/new'
    | '/verify/$uidb64/$token'
    | '/organizations/'
    | '/profile/'
    | '/devices/new'
    | '/settings/access'
    | '/settings/details'
    | '/organizations/$organizationId/billing'
    | '/organizations/$organizationId/members'
    | '/organizations/$organizationId/settings'
    | '/organizations/$organizationId/supply-points'
    | '/devices/'
    | '/settings/'
    | '/organizations/$organizationId/'
    | '/devices/$deviceId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/sign-up'
    | '/verify-email'
    | '/billing'
    | '/no-supply-points'
    | '/accept-invitation/$token'
    | '/reset-password/$token'
    | '/products'
    | '/profile/personal-info'
    | '/profile/security'
    | '/supply-points/new'
    | '/verify/$uidb64/$token'
    | '/organizations'
    | '/profile'
    | '/devices/new'
    | '/settings/access'
    | '/settings/details'
    | '/organizations/$organizationId/billing'
    | '/organizations/$organizationId/members'
    | '/organizations/$organizationId/settings'
    | '/organizations/$organizationId/supply-points'
    | '/devices'
    | '/settings'
    | '/organizations/$organizationId'
    | '/devices/$deviceId/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/sign-up'
    | '/verify-email'
    | '/_authenticated/organizations'
    | '/_authenticated/profile'
    | '/_authenticated/_supply-point-scope'
    | '/_authenticated/billing'
    | '/_authenticated/no-supply-points'
    | '/accept-invitation/$token'
    | '/reset-password/$token'
    | '/_authenticated/_supply-point-scope/devices'
    | '/_authenticated/_supply-point-scope/settings'
    | '/_authenticated/organizations/$organizationId'
    | '/_authenticated/_supply-point-scope/products'
    | '/_authenticated/profile/personal-info'
    | '/_authenticated/profile/security'
    | '/_authenticated/supply-points/new'
    | '/verify/$uidb64/$token'
    | '/_authenticated/_supply-point-scope/'
    | '/_authenticated/organizations/'
    | '/_authenticated/profile/'
    | '/_authenticated/_supply-point-scope/devices/new'
    | '/_authenticated/_supply-point-scope/settings/access'
    | '/_authenticated/_supply-point-scope/settings/details'
    | '/_authenticated/organizations/$organizationId/billing'
    | '/_authenticated/organizations/$organizationId/members'
    | '/_authenticated/organizations/$organizationId/settings'
    | '/_authenticated/organizations/$organizationId/supply-points'
    | '/_authenticated/_supply-point-scope/devices/'
    | '/_authenticated/_supply-point-scope/settings/'
    | '/_authenticated/organizations/$organizationId/'
    | '/_authenticated/_supply-point-scope/devices/$deviceId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  SignUpRoute: typeof SignUpRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AcceptInvitationTokenRoute: typeof AcceptInvitationTokenRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
  VerifyUidb64TokenRoute: typeof VerifyUidb64TokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation/$token': {
      id: '/accept-invitation/$token'
      path: '/accept-invitation/$token'
      fullPath: '/accept-invitation/$token'
      preLoaderRoute: typeof AcceptInvitationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/no-supply-points': {
      id: '/_authenticated/no-supply-points'
      path: '/no-supply-points'
      fullPath: '/no-supply-points'
      preLoaderRoute: typeof AuthenticatedNoSupplyPointsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing': {
      id: '/_authenticated/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthenticatedBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_supply-point-scope': {
      id: '/_authenticated/_supply-point-scope'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedSupplyPointScopeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations': {
      id: '/_authenticated/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedOrganizationsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedProfileRouteRoute
    }
    '/_authenticated/organizations/': {
      id: '/_authenticated/organizations/'
      path: '/'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthenticatedOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationsRouteRoute
    }
    '/_authenticated/_supply-point-scope/': {
      id: '/_authenticated/_supply-point-scope/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedSupplyPointScopeIndexRouteImport
      parentRoute: typeof AuthenticatedSupplyPointScopeRoute
    }
    '/verify/$uidb64/$token': {
      id: '/verify/$uidb64/$token'
      path: '/verify/$uidb64/$token'
      fullPath: '/verify/$uidb64/$token'
      preLoaderRoute: typeof VerifyUidb64TokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/supply-points/new': {
      id: '/_authenticated/supply-points/new'
      path: '/supply-points/new'
      fullPath: '/supply-points/new'
      preLoaderRoute: typeof AuthenticatedSupplyPointsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/security': {
      id: '/_authenticated/profile/security'
      path: '/security'
      fullPath: '/profile/security'
      preLoaderRoute: typeof AuthenticatedProfileSecurityRouteImport
      parentRoute: typeof AuthenticatedProfileRouteRoute
    }
    '/_authenticated/profile/personal-info': {
      id: '/_authenticated/profile/personal-info'
      path: '/personal-info'
      fullPath: '/profile/personal-info'
      preLoaderRoute: typeof AuthenticatedProfilePersonalInfoRouteImport
      parentRoute: typeof AuthenticatedProfileRouteRoute
    }
    '/_authenticated/_supply-point-scope/products': {
      id: '/_authenticated/_supply-point-scope/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AuthenticatedSupplyPointScopeProductsRouteImport
      parentRoute: typeof AuthenticatedSupplyPointScopeRoute
    }
    '/_authenticated/organizations/$organizationId': {
      id: '/_authenticated/organizations/$organizationId'
      path: '/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrganizationsRouteRoute
    }
    '/_authenticated/_supply-point-scope/settings': {
      id: '/_authenticated/_supply-point-scope/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSupplyPointScopeSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedSupplyPointScopeRoute
    }
    '/_authenticated/_supply-point-scope/devices': {
      id: '/_authenticated/_supply-point-scope/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AuthenticatedSupplyPointScopeDevicesRouteRouteImport
      parentRoute: typeof AuthenticatedSupplyPointScopeRoute
    }
    '/_authenticated/organizations/$organizationId/': {
      id: '/_authenticated/organizations/$organizationId/'
      path: '/'
      fullPath: '/organizations/$organizationId/'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationsOrganizationIdRouteRoute
    }
    '/_authenticated/_supply-point-scope/settings/': {
      id: '/_authenticated/_supply-point-scope/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSupplyPointScopeSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSupplyPointScopeSettingsRouteRoute
    }
    '/_authenticated/_supply-point-scope/devices/': {
      id: '/_authenticated/_supply-point-scope/devices/'
      path: '/'
      fullPath: '/devices/'
      preLoaderRoute: typeof AuthenticatedSupplyPointScopeDevicesIndexRouteImport
      parentRoute: typeof AuthenticatedSupplyPointScopeDevicesRouteRoute
    }
    '/_authenticated/organizations/$organizationId/supply-points': {
      id: '/_authenticated/organizations/$organizationId/supply-points'
      path: '/supply-points'
      fullPath: '/organizations/$organizationId/supply-points'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationIdSupplyPointsRouteImport
      parentRoute: typeof AuthenticatedOrganizationsOrganizationIdRouteRoute
    }
    '/_authenticated/organizations/$organizationId/settings': {
      id: '/_authenticated/organizations/$organizationId/settings'
      path: '/settings'
      fullPath: '/organizations/$organizationId/settings'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationIdSettingsRouteImport
      parentRoute: typeof AuthenticatedOrganizationsOrganizationIdRouteRoute
    }
    '/_authenticated/organizations/$organizationId/members': {
      id: '/_authenticated/organizations/$organizationId/members'
      path: '/members'
      fullPath: '/organizations/$organizationId/members'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationIdMembersRouteImport
      parentRoute: typeof AuthenticatedOrganizationsOrganizationIdRouteRoute
    }
    '/_authenticated/organizations/$organizationId/billing': {
      id: '/_authenticated/organizations/$organizationId/billing'
      path: '/billing'
      fullPath: '/organizations/$organizationId/billing'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationIdBillingRouteImport
      parentRoute: typeof AuthenticatedOrganizationsOrganizationIdRouteRoute
    }
    '/_authenticated/_supply-point-scope/settings/details': {
      id: '/_authenticated/_supply-point-scope/settings/details'
      path: '/details'
      fullPath: '/settings/details'
      preLoaderRoute: typeof AuthenticatedSupplyPointScopeSettingsDetailsRouteImport
      parentRoute: typeof AuthenticatedSupplyPointScopeSettingsRouteRoute
    }
    '/_authenticated/_supply-point-scope/settings/access': {
      id: '/_authenticated/_supply-point-scope/settings/access'
      path: '/access'
      fullPath: '/settings/access'
      preLoaderRoute: typeof AuthenticatedSupplyPointScopeSettingsAccessRouteImport
      parentRoute: typeof AuthenticatedSupplyPointScopeSettingsRouteRoute
    }
    '/_authenticated/_supply-point-scope/devices/new': {
      id: '/_authenticated/_supply-point-scope/devices/new'
      path: '/new'
      fullPath: '/devices/new'
      preLoaderRoute: typeof AuthenticatedSupplyPointScopeDevicesNewRouteImport
      parentRoute: typeof AuthenticatedSupplyPointScopeDevicesRouteRoute
    }
    '/_authenticated/_supply-point-scope/devices/$deviceId/edit': {
      id: '/_authenticated/_supply-point-scope/devices/$deviceId/edit'
      path: '/$deviceId/edit'
      fullPath: '/devices/$deviceId/edit'
      preLoaderRoute: typeof AuthenticatedSupplyPointScopeDevicesDeviceIdEditRouteImport
      parentRoute: typeof AuthenticatedSupplyPointScopeDevicesRouteRoute
    }
  }
}

interface AuthenticatedOrganizationsOrganizationIdRouteRouteChildren {
  AuthenticatedOrganizationsOrganizationIdBillingRoute: typeof AuthenticatedOrganizationsOrganizationIdBillingRoute
  AuthenticatedOrganizationsOrganizationIdMembersRoute: typeof AuthenticatedOrganizationsOrganizationIdMembersRoute
  AuthenticatedOrganizationsOrganizationIdSettingsRoute: typeof AuthenticatedOrganizationsOrganizationIdSettingsRoute
  AuthenticatedOrganizationsOrganizationIdSupplyPointsRoute: typeof AuthenticatedOrganizationsOrganizationIdSupplyPointsRoute
  AuthenticatedOrganizationsOrganizationIdIndexRoute: typeof AuthenticatedOrganizationsOrganizationIdIndexRoute
}

const AuthenticatedOrganizationsOrganizationIdRouteRouteChildren: AuthenticatedOrganizationsOrganizationIdRouteRouteChildren =
  {
    AuthenticatedOrganizationsOrganizationIdBillingRoute:
      AuthenticatedOrganizationsOrganizationIdBillingRoute,
    AuthenticatedOrganizationsOrganizationIdMembersRoute:
      AuthenticatedOrganizationsOrganizationIdMembersRoute,
    AuthenticatedOrganizationsOrganizationIdSettingsRoute:
      AuthenticatedOrganizationsOrganizationIdSettingsRoute,
    AuthenticatedOrganizationsOrganizationIdSupplyPointsRoute:
      AuthenticatedOrganizationsOrganizationIdSupplyPointsRoute,
    AuthenticatedOrganizationsOrganizationIdIndexRoute:
      AuthenticatedOrganizationsOrganizationIdIndexRoute,
  }

const AuthenticatedOrganizationsOrganizationIdRouteRouteWithChildren =
  AuthenticatedOrganizationsOrganizationIdRouteRoute._addFileChildren(
    AuthenticatedOrganizationsOrganizationIdRouteRouteChildren,
  )

interface AuthenticatedOrganizationsRouteRouteChildren {
  AuthenticatedOrganizationsOrganizationIdRouteRoute: typeof AuthenticatedOrganizationsOrganizationIdRouteRouteWithChildren
  AuthenticatedOrganizationsIndexRoute: typeof AuthenticatedOrganizationsIndexRoute
}

const AuthenticatedOrganizationsRouteRouteChildren: AuthenticatedOrganizationsRouteRouteChildren =
  {
    AuthenticatedOrganizationsOrganizationIdRouteRoute:
      AuthenticatedOrganizationsOrganizationIdRouteRouteWithChildren,
    AuthenticatedOrganizationsIndexRoute: AuthenticatedOrganizationsIndexRoute,
  }

const AuthenticatedOrganizationsRouteRouteWithChildren =
  AuthenticatedOrganizationsRouteRoute._addFileChildren(
    AuthenticatedOrganizationsRouteRouteChildren,
  )

interface AuthenticatedProfileRouteRouteChildren {
  AuthenticatedProfilePersonalInfoRoute: typeof AuthenticatedProfilePersonalInfoRoute
  AuthenticatedProfileSecurityRoute: typeof AuthenticatedProfileSecurityRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
}

const AuthenticatedProfileRouteRouteChildren: AuthenticatedProfileRouteRouteChildren =
  {
    AuthenticatedProfilePersonalInfoRoute:
      AuthenticatedProfilePersonalInfoRoute,
    AuthenticatedProfileSecurityRoute: AuthenticatedProfileSecurityRoute,
    AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  }

const AuthenticatedProfileRouteRouteWithChildren =
  AuthenticatedProfileRouteRoute._addFileChildren(
    AuthenticatedProfileRouteRouteChildren,
  )

interface AuthenticatedSupplyPointScopeDevicesRouteRouteChildren {
  AuthenticatedSupplyPointScopeDevicesNewRoute: typeof AuthenticatedSupplyPointScopeDevicesNewRoute
  AuthenticatedSupplyPointScopeDevicesIndexRoute: typeof AuthenticatedSupplyPointScopeDevicesIndexRoute
  AuthenticatedSupplyPointScopeDevicesDeviceIdEditRoute: typeof AuthenticatedSupplyPointScopeDevicesDeviceIdEditRoute
}

const AuthenticatedSupplyPointScopeDevicesRouteRouteChildren: AuthenticatedSupplyPointScopeDevicesRouteRouteChildren =
  {
    AuthenticatedSupplyPointScopeDevicesNewRoute:
      AuthenticatedSupplyPointScopeDevicesNewRoute,
    AuthenticatedSupplyPointScopeDevicesIndexRoute:
      AuthenticatedSupplyPointScopeDevicesIndexRoute,
    AuthenticatedSupplyPointScopeDevicesDeviceIdEditRoute:
      AuthenticatedSupplyPointScopeDevicesDeviceIdEditRoute,
  }

const AuthenticatedSupplyPointScopeDevicesRouteRouteWithChildren =
  AuthenticatedSupplyPointScopeDevicesRouteRoute._addFileChildren(
    AuthenticatedSupplyPointScopeDevicesRouteRouteChildren,
  )

interface AuthenticatedSupplyPointScopeSettingsRouteRouteChildren {
  AuthenticatedSupplyPointScopeSettingsAccessRoute: typeof AuthenticatedSupplyPointScopeSettingsAccessRoute
  AuthenticatedSupplyPointScopeSettingsDetailsRoute: typeof AuthenticatedSupplyPointScopeSettingsDetailsRoute
  AuthenticatedSupplyPointScopeSettingsIndexRoute: typeof AuthenticatedSupplyPointScopeSettingsIndexRoute
}

const AuthenticatedSupplyPointScopeSettingsRouteRouteChildren: AuthenticatedSupplyPointScopeSettingsRouteRouteChildren =
  {
    AuthenticatedSupplyPointScopeSettingsAccessRoute:
      AuthenticatedSupplyPointScopeSettingsAccessRoute,
    AuthenticatedSupplyPointScopeSettingsDetailsRoute:
      AuthenticatedSupplyPointScopeSettingsDetailsRoute,
    AuthenticatedSupplyPointScopeSettingsIndexRoute:
      AuthenticatedSupplyPointScopeSettingsIndexRoute,
  }

const AuthenticatedSupplyPointScopeSettingsRouteRouteWithChildren =
  AuthenticatedSupplyPointScopeSettingsRouteRoute._addFileChildren(
    AuthenticatedSupplyPointScopeSettingsRouteRouteChildren,
  )

interface AuthenticatedSupplyPointScopeRouteChildren {
  AuthenticatedSupplyPointScopeDevicesRouteRoute: typeof AuthenticatedSupplyPointScopeDevicesRouteRouteWithChildren
  AuthenticatedSupplyPointScopeSettingsRouteRoute: typeof AuthenticatedSupplyPointScopeSettingsRouteRouteWithChildren
  AuthenticatedSupplyPointScopeProductsRoute: typeof AuthenticatedSupplyPointScopeProductsRoute
  AuthenticatedSupplyPointScopeIndexRoute: typeof AuthenticatedSupplyPointScopeIndexRoute
}

const AuthenticatedSupplyPointScopeRouteChildren: AuthenticatedSupplyPointScopeRouteChildren =
  {
    AuthenticatedSupplyPointScopeDevicesRouteRoute:
      AuthenticatedSupplyPointScopeDevicesRouteRouteWithChildren,
    AuthenticatedSupplyPointScopeSettingsRouteRoute:
      AuthenticatedSupplyPointScopeSettingsRouteRouteWithChildren,
    AuthenticatedSupplyPointScopeProductsRoute:
      AuthenticatedSupplyPointScopeProductsRoute,
    AuthenticatedSupplyPointScopeIndexRoute:
      AuthenticatedSupplyPointScopeIndexRoute,
  }

const AuthenticatedSupplyPointScopeRouteWithChildren =
  AuthenticatedSupplyPointScopeRoute._addFileChildren(
    AuthenticatedSupplyPointScopeRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedOrganizationsRouteRoute: typeof AuthenticatedOrganizationsRouteRouteWithChildren
  AuthenticatedProfileRouteRoute: typeof AuthenticatedProfileRouteRouteWithChildren
  AuthenticatedSupplyPointScopeRoute: typeof AuthenticatedSupplyPointScopeRouteWithChildren
  AuthenticatedBillingRoute: typeof AuthenticatedBillingRoute
  AuthenticatedNoSupplyPointsRoute: typeof AuthenticatedNoSupplyPointsRoute
  AuthenticatedSupplyPointsNewRoute: typeof AuthenticatedSupplyPointsNewRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedOrganizationsRouteRoute:
    AuthenticatedOrganizationsRouteRouteWithChildren,
  AuthenticatedProfileRouteRoute: AuthenticatedProfileRouteRouteWithChildren,
  AuthenticatedSupplyPointScopeRoute:
    AuthenticatedSupplyPointScopeRouteWithChildren,
  AuthenticatedBillingRoute: AuthenticatedBillingRoute,
  AuthenticatedNoSupplyPointsRoute: AuthenticatedNoSupplyPointsRoute,
  AuthenticatedSupplyPointsNewRoute: AuthenticatedSupplyPointsNewRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  SignUpRoute: SignUpRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AcceptInvitationTokenRoute: AcceptInvitationTokenRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
  VerifyUidb64TokenRoute: VerifyUidb64TokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
